import videojs from 'video.js';

export class Item extends videojs.getComponent('ClickableComponent') {
	constructor(player, options) {
		super(player, options);
	}

	// handleClick(event) {
	// 	this.addClass('vjs-selected');
	// }

	createEl() {
		return super.createEl('li');
	}
}
